import { render, staticRenderFns } from "./TheCartSection.vue?vue&type=template&id=f38ed45c&scoped=true&name=the-cart-section&"
import script from "./TheCartSection.vue?vue&type=script&lang=js&"
export * from "./TheCartSection.vue?vue&type=script&lang=js&"
import style0 from "./TheCartSection.vue?vue&type=style&index=0&id=f38ed45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38ed45c",
  null
  
)

/* custom blocks */
import block0 from "./TheCartSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports